import CustomDrawer from "../shared/CustomDrawer";
import { useRequest } from "../../api/utils/useRequest";
import { BalootUserAPIs } from "../../api/APIs";
import DrawerActionItem from "../shared/DrawerActionItem";
import { ReactComponent as DisableIcon } from "../../assets/icons/disable-colored.svg";
import { ReactComponent as EnableIcon } from "../../assets/icons/enable-colored.svg";
import { ActionModal } from "../shared/ActionModal";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setConfig } from "../../store/actions/ConfigActions";

export function AutoInvestmentStatusBottomSheet(props) {
  const { open, setOpen, enabled, setAutoInvestmentStatus } = props;
  const [openModal, setOpenModal] = useState(false);
  const { loading, apiCall: setAutoInvestmentState } = useRequest(
    BalootUserAPIs.setAutoInvestmentState
  );
  const dispatch = useDispatch();
  const { config } = useSelector((state) => state.config);

  const setStatus = (enabled) => {
    setAutoInvestmentState({
      data: { enabled },
      onSuccess: () => {
        //update config state to show status on gholak
        dispatch(
          setConfig({
            config: {
              ...config,
              profile: {
                ...config.profile,
                hasAutoInvestment: enabled,
              },
            },
          })
        );
        setAutoInvestmentStatus((prev) => {
          return { ...prev, enabled: enabled };
        });
        setOpenModal(false);
        setOpen(false);
      },
    });
  };

  return (
    <CustomDrawer
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      {enabled ? (
        <DrawerActionItem
          onClick={() => {
            setOpenModal(true);
          }}
          icon={DisableIcon}
          title="غیرفعال‌سازی سرمایه‌گذاری خودکار"
        />
      ) : (
        <DrawerActionItem
          loading={loading}
          onClick={() => {
            setStatus(true);
          }}
          icon={EnableIcon}
          title="فعال‌سازی سرمایه‌گذاری خودکار"
        />
      )}
      <ActionModal
        open={openModal}
        setOpen={setOpenModal}
        title="غیر فعال‌سازی"
        description="آيا از غیر فعال‌سازی سرمایه‌گذاری خودکار مطمئن هستید؟"
        isContained={false}
        actionTitle="غیرفعال‌سازی"
        action={() => setStatus(false)}
        cancelTitle="بستن"
        loading={loading}
      />
    </CustomDrawer>
  );
}
